import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[1050] flex items-center justify-center p-0 sm:p-4"
}
const _hoisted_2 = { class: "flex items-center justify-between gap-2 px-3 sm:px-6 py-2.5 sm:py-2 border-b border-gray-100 flex-shrink-0" }
const _hoisted_3 = { class: "min-w-0 flex-shrink-0 max-w-[7rem] sm:max-w-none" }
const _hoisted_4 = { class: "text-base sm:text-lg font-semibold text-black truncate" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-black mt-0.5 truncate"
}
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = {
  key: 0,
  class: "relative ml-auto min-w-0 max-w-md flex-1"
}
const _hoisted_8 = ["aria-expanded", "onKeydown"]
const _hoisted_9 = {
  key: 1,
  class: "absolute left-0 right-0 top-full z-50 mt-1 max-h-64 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg",
  role: "listbox"
}
const _hoisted_10 = {
  key: 0,
  class: "px-3 py-3 text-sm text-gray-500"
}
const _hoisted_11 = ["disabled", "onMousedown"]
const _hoisted_12 = { class: "truncate" }
const _hoisted_13 = {
  key: 0,
  class: "ml-auto flex-shrink-0 text-xs text-gray-500"
}
const _hoisted_14 = {
  key: 1,
  class: "hidden text-xs font-medium text-black sm:inline sm:whitespace-nowrap"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex flex-col gap-4 mb-6" }
const _hoisted_17 = {
  key: 0,
  class: "relative md:order-2"
}
const _hoisted_18 = { class: "flex gap-3 overflow-x-auto flex-nowrap" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bg-blue-500 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded-b text-center leading-tight"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["href", "download"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "absolute right-0 top-0 bottom-0 w-8 flex items-center justify-center bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none"
}
const _hoisted_27 = {
  key: 1,
  class: "flex flex-col flex-1 min-h-0"
}
const _hoisted_28 = { class: "flex md:hidden flex-col border-b border-gray-100 flex-shrink-0 overscroll-contain" }
const _hoisted_29 = { class: "collapse-panel__inner" }
const _hoisted_30 = { class: "flex gap-2 px-3 pb-2 overflow-x-auto" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "opacity-80"
}
const _hoisted_33 = { class: "collapse-panel__inner" }
const _hoisted_34 = { class: "flex gap-2 px-3 pb-2 overflow-x-auto" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "opacity-80"
}
const _hoisted_37 = { class: "flex flex-1 min-h-0 overflow-hidden" }
const _hoisted_38 = { class: "hidden md:block w-44 lg:w-48 flex-shrink-0 bg-gray-50 border-r border-gray-200 overflow-y-auto overscroll-contain" }
const _hoisted_39 = { class: "collapse-panel__inner collapse-panel__inner--sidebar" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "truncate flex-1" }
const _hoisted_42 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_43 = { class: "collapse-panel__inner collapse-panel__inner--sidebar" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "truncate flex-1" }
const _hoisted_46 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_47 = { class: "flex-1 overflow-y-auto overscroll-contain p-3 sm:p-5" }
const _hoisted_48 = {
  key: 0,
  class: "text-sm font-medium text-black mb-3 capitalize"
}
const _hoisted_49 = {
  key: 1,
  class: "text-sm text-gray-500 py-8 text-center"
}
const _hoisted_50 = {
  key: 2,
  class: "grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-4 sm:gap-x-6 sm:gap-y-5"
}
const _hoisted_51 = ["title", "disabled", "onClick"]
const _hoisted_52 = { class: "truncate" }
const _hoisted_53 = {
  key: 0,
  class: "text-[10px] text-gray-500"
}
const _hoisted_54 = {
  key: 0,
  class: "fas fa-check text-[10px] flex-shrink-0"
}
const _hoisted_55 = {
  key: 0,
  class: "absolute -top-1 -right-1 w-4 h-4 rounded-full bg-black text-white flex items-center justify-center shadow"
}
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { class: "flex flex-wrap gap-2 border-b border-gray-200 mb-4" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-amber-100 text-amber-500",
  title: "Aucune photo — sera créée en brouillon"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "text-sm text-black mb-3" }
const _hoisted_62 = { class: "text-blue-700" }
const _hoisted_63 = {
  key: 0,
  class: "relative mb-3"
}
const _hoisted_64 = { class: "flex gap-3 overflow-x-auto flex-nowrap" }
const _hoisted_65 = ["onClick", "onDragstart", "onDragover", "onDrop"]
const _hoisted_66 = ["src", "alt"]
const _hoisted_67 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bg-blue-500 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded-b text-center leading-tight"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["href", "download"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 0,
  class: "absolute right-0 top-0 bottom-0 w-8 flex items-center justify-center bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none"
}
const _hoisted_73 = { class: "text-black" }
const _hoisted_74 = { class: "px-3 sm:px-6 py-3 sm:py-4 border-t border-gray-100 flex-shrink-0 safe-area-pb" }
const _hoisted_75 = {
  key: 0,
  class: "mb-3 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700"
}
const _hoisted_76 = { class: "flex justify-between gap-2 sm:gap-3" }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "flex flex-wrap justify-end gap-2 sm:gap-3" }
const _hoisted_79 = ["disabled", "onKeydown"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }

import { computed, nextTick, ref, watch, onBeforeUnmount } from "vue";
import type { ProduitCatalogue } from "@/types";
import type { CouleurAPI } from "@/types/mel-components";
import {
  type BasicColorFamily,
  type BasicColorFamilyId,
  getColorSwatchStyle,
  getFamiliesWithVendorColors,
  groupVendorColorsByBasicFamily,
} from "@/utils/colorFamilies";
import {
  type MotifCategory,
  formatMotifPanelTitle,
  getMotifCategoriesWithColors,
  groupMotifsByCategory,
  splitSolidAndMotifColors,
} from "@/utils/motifFamilies";

type PickerSection = "couleurs" | "motifs";

export interface ColorOption {
  id_couleur: number;
  label: string;
  hexColor?: string | null;
  motifCategorie?: string | null;
  idCouleurEfashion?: number | null;
  officiel?: number | null;
}

interface Props {
  visible: boolean;
  product: ProduitCatalogue | null;
  sourceProductId?: number | null;
  colors: ColorOption[];
  disabledColorIds?: number[];
  venduPar?: string;
}

interface ColorPhotoEntry {
  files: File[];
  previews: Map<File, string>;
  rotations: Map<File, number>;
  coverIndex: number;
}

interface Emits {
  (e: "update:visible", value: boolean): void;
  (
    e: "save",
    payload: {
      productId: number;
      variants: Array<{
        couleurId: number;
        couleurName: string;
        photos?: File[];
        rotations?: number[];
      }>;
    },
  ): void;
  (
    e: "saveAndPublish",
    payload: {
      productId: number;
      variants: Array<{
        couleurId: number;
        couleurName: string;
        photos?: File[];
        rotations?: number[];
      }>;
    },
  ): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewColorsModal',
  props: {
    visible: { type: Boolean },
    product: {},
    sourceProductId: {},
    colors: {},
    disabledColorIds: {},
    venduPar: {}
  },
  emits: ["update:visible", "save", "saveAndPublish"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const duplicateSourceProductId = computed(() => {
  const fromLiaison = Number(props.sourceProductId);
  if (!Number.isNaN(fromLiaison) && fromLiaison > 0) return fromLiaison;
  return Number(props.product?.id) || 0;
});

// Étape courante (1 = sélection couleurs, 2 = upload photos)
const currentStep = ref(1);

// Sélection multiple de couleurs
const localSelectedIds = ref<number[]>([]);

// Couleur active dans l'onglet (étape 2)
const activeColorId = ref<number | null>(null);

// Stockage des photos par couleur
const colorPhotos = ref<Map<number, ColorPhotoEntry>>(new Map());

// Recherche de couleurs
const searchQuery = ref<string>("");
const searchInputRef = ref<HTMLInputElement | null>(null);
const confirmButtonRef = ref<HTMLButtonElement | null>(null);
const isSearchDropdownOpen = ref(false);
const highlightedSearchIndex = ref(-1);
const activeSection = ref<PickerSection>("couleurs");
const activeFamilyId = ref<BasicColorFamilyId>("beige");
const activeMotifCategory = ref<MotifCategory>("Animaux");
const couleursSectionOpen = ref(true);
const motifsSectionOpen = ref(false);

// Mode mélangées : fichiers séparés
const melangeesFiles = ref<File[]>([]);
const melangeesFilePreviews = ref<Map<File, string>>(new Map());
const melangeesFileRotations = ref<Map<File, number>>(new Map());
const melangesCoverIndex = ref<number>(0);

const isDragging = ref(false);
const isUploading = ref(false);
const uploadError = ref<string | null>(null);

const activeOverlay = ref<string | null>(null);

function toggleOverlay(mode: string, index: number) {
  const key = `${mode}-${index}`;
  activeOverlay.value = activeOverlay.value === key ? null : key;
}

const ALLOWED_PHOTO_TYPES = new Set([
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/x-adobe-dng",
  "image/dng",
]);

const disabledIds = computed(() => {
  const ids = props.disabledColorIds || [];
  return ids.map((id) => Number(id)).filter((n) => !Number.isNaN(n));
});

const isColorDisabled = (id: number | string) =>
  disabledIds.value.includes(Number(id));

watch(
  () => props.visible,
  (val) => {
    if (val) {
      localSelectedIds.value = [];
      searchQuery.value = "";
      currentStep.value = 1;
      activeColorId.value = null;
      activeSection.value = "couleurs";
      activeFamilyId.value =
        getFamiliesWithVendorColors(
          props.colors.map((c) => ({
            id_couleur: c.id_couleur,
            couleur_FR: c.label,
            couleur_EN: null,
            hexColor: c.hexColor ?? null,
            motifCategorie: c.motifCategorie ?? null,
          })).filter((c) => !c.motifCategorie),
        )[0]?.id || "beige";
      activeMotifCategory.value =
        getMotifCategoriesWithColors(
          props.colors
            .filter((c) => c.motifCategorie)
            .map((c) => ({
              id_couleur: c.id_couleur,
              couleur_FR: c.label,
              couleur_EN: null,
              hexColor: c.hexColor ?? null,
              motifCategorie: c.motifCategorie ?? null,
            })),
        )[0]?.id || "Animaux";

      const solidFamilies = getFamiliesWithVendorColors(
        props.colors
          .filter((c) => !c.motifCategorie)
          .map((c) => ({
            id_couleur: c.id_couleur,
            couleur_FR: c.label,
            couleur_EN: null,
            hexColor: c.hexColor ?? null,
          })),
      );
      const motifCats = getMotifCategoriesWithColors(
        props.colors
          .filter((c) => c.motifCategorie)
          .map((c) => ({
            id_couleur: c.id_couleur,
            couleur_FR: c.label,
            couleur_EN: null,
            hexColor: c.hexColor ?? null,
            motifCategorie: c.motifCategorie ?? null,
          })),
      );

      if (solidFamilies.length) {
        activeSection.value = "couleurs";
        activeFamilyId.value = solidFamilies[0]?.id || "beige";
        couleursSectionOpen.value = true;
        motifsSectionOpen.value = false;
      } else if (motifCats.length) {
        activeSection.value = "motifs";
        activeMotifCategory.value = motifCats[0].id;
        couleursSectionOpen.value = false;
        motifsSectionOpen.value = true;
      }
      colorPhotos.value = new Map();
      melangeesFiles.value = [];
      melangeesFilePreviews.value = new Map();
      melangeesFileRotations.value = new Map();
      melangesCoverIndex.value = 0;
      uploadError.value = null;
      document.body.style.overflow = "hidden";
      void nextTick(() => searchInputRef.value?.focus());
    } else {
      document.body.style.overflow = "";
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  document.body.style.overflow = "";
});

const normalize = (s: string) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}+/gu, "");

const colorsAsApi = computed<CouleurAPI[]>(() =>
  props.colors.map((c) => ({
    id_couleur: c.id_couleur,
    couleur_FR: c.label,
    couleur_EN: null,
    hexColor: c.hexColor ?? null,
    motifCategorie: c.motifCategorie ?? null,
    idCouleurEfashion: c.idCouleurEfashion ?? null,
    officiel: c.officiel ?? 1,
  })),
);

const solidColorsRef = computed(
  () => splitSolidAndMotifColors(colorsAsApi.value).solid,
);
const motifColorsRef = computed(
  () => splitSolidAndMotifColors(colorsAsApi.value).motifs,
);

const colorGroups = computed(() =>
  groupVendorColorsByBasicFamily(solidColorsRef.value),
);

const motifGroups = computed(() => groupMotifsByCategory(motifColorsRef.value));

const matchesSearch = (color: CouleurAPI, term: string) =>
  normalize(color.couleur_FR || "").includes(term);

const searchResults = computed(() => {
  const term = normalize(searchQuery.value);
  if (!term) return [];
  return props.colors.filter(
    (color) =>
      !localSelectedIds.value.includes(color.id_couleur) &&
      normalize(color.label).includes(term),
  );
});

const visibleColorFamilies = computed(() => {
  if (searchQuery.value) {
    const term = normalize(searchQuery.value);
    return getFamiliesWithVendorColors(solidColorsRef.value).filter((family) =>
      (colorGroups.value[family.id] || []).some((color) =>
        matchesSearch(color, term),
      ),
    );
  }
  return getFamiliesWithVendorColors(solidColorsRef.value);
});

const visibleMotifCategories = computed(() => {
  if (searchQuery.value) {
    const term = normalize(searchQuery.value);
    return getMotifCategoriesWithColors(motifColorsRef.value).filter(
      (category) =>
        (motifGroups.value[category.id] || []).some((color) =>
          matchesSearch(color, term),
        ),
    );
  }
  return getMotifCategoriesWithColors(motifColorsRef.value);
});

const displayedShades = computed(() => {
  const term = searchQuery.value ? normalize(searchQuery.value) : "";

  if (activeSection.value === "motifs") {
    let list = (motifGroups.value[activeMotifCategory.value] || []).map(
      (color) => ({
        id_couleur: Number(color.id_couleur),
        label: color.couleur_FR || "",
        hexColor: color.hexColor ?? null,
      }),
    );
    if (term) list = list.filter((color) => normalize(color.label).includes(term));
    return list;
  }

  let list = (colorGroups.value[activeFamilyId.value] || []).map((color) => ({
    id_couleur: Number(color.id_couleur),
    label: color.couleur_FR || "",
    hexColor: color.hexColor ?? null,
  }));
  if (term) list = list.filter((color) => normalize(color.label).includes(term));
  return list;
});

const panelTitle = computed(() => {
  if (activeSection.value === "motifs") {
    return formatMotifPanelTitle(activeMotifCategory.value);
  }
  const family = visibleColorFamilies.value.find(
    (item) => item.id === activeFamilyId.value,
  );
  return family ? `Nuances de ${family.label.toLowerCase()}` : "";
});

const pendingCountByColorFamily = computed(() => {
  const counts: Partial<Record<BasicColorFamilyId, number>> = {};
  for (const family of visibleColorFamilies.value) {
    const count = (colorGroups.value[family.id] || []).filter((color) =>
      localSelectedIds.value.includes(Number(color.id_couleur)),
    ).length;
    if (count > 0) counts[family.id] = count;
  }
  return counts;
});

const pendingCountByMotifCategory = computed(() => {
  const counts: Partial<Record<MotifCategory, number>> = {};
  for (const category of visibleMotifCategories.value) {
    const count = (motifGroups.value[category.id] || []).filter((color) =>
      localSelectedIds.value.includes(Number(color.id_couleur)),
    ).length;
    if (count > 0) counts[category.id] = count;
  }
  return counts;
});

const isActiveNav = (section: PickerSection, id: string) =>
  activeSection.value === section &&
  (section === "couleurs"
    ? activeFamilyId.value === id
    : activeMotifCategory.value === id);

const navButtonClass = (section: PickerSection, id: string) =>
  isActiveNav(section, id)
    ? "bg-black text-white border-black"
    : "bg-white text-black border-gray-300";

const sidebarItemClass = (section: PickerSection, id: string) =>
  isActiveNav(section, id)
    ? "bg-white text-black font-medium shadow-sm"
    : "text-gray-700 hover:bg-white/70";

const selectColorFamily = (familyId: BasicColorFamilyId) => {
  activeSection.value = "couleurs";
  activeFamilyId.value = familyId;
  couleursSectionOpen.value = true;
  motifsSectionOpen.value = false;
};

const selectMotifCategory = (category: MotifCategory) => {
  activeSection.value = "motifs";
  activeMotifCategory.value = category;
  motifsSectionOpen.value = true;
  couleursSectionOpen.value = false;
};

const toggleCouleursSection = () => {
  const willOpen = !couleursSectionOpen.value;
  couleursSectionOpen.value = willOpen;
  if (willOpen) motifsSectionOpen.value = false;
};

const toggleMotifsSection = () => {
  const willOpen = !motifsSectionOpen.value;
  motifsSectionOpen.value = willOpen;
  if (willOpen) couleursSectionOpen.value = false;
};

const familySwatchStyle = (family: BasicColorFamily) => {
  if (family.swatch.startsWith("linear-gradient")) {
    return { backgroundImage: family.swatch };
  }
  return { backgroundColor: family.swatch };
};

watch([visibleColorFamilies, visibleMotifCategories], ([families, categories]) => {
  if (
    activeSection.value === "couleurs" &&
    !families.find((family) => family.id === activeFamilyId.value)
  ) {
    if (families[0]) {
      activeFamilyId.value = families[0].id;
    } else if (categories[0]) {
      activeSection.value = "motifs";
      activeMotifCategory.value = categories[0].id;
      motifsSectionOpen.value = true;
      couleursSectionOpen.value = false;
    }
  }

  if (
    activeSection.value === "motifs" &&
    !categories.find((category) => category.id === activeMotifCategory.value)
  ) {
    if (categories[0]) {
      activeMotifCategory.value = categories[0].id;
    } else if (families[0]) {
      activeSection.value = "couleurs";
      activeFamilyId.value = families[0].id;
      couleursSectionOpen.value = true;
      motifsSectionOpen.value = false;
    }
  }
});

watch(searchQuery, () => {
  if (!searchQuery.value) return;
  if (visibleColorFamilies.value[0]) {
    activeSection.value = "couleurs";
    activeFamilyId.value = visibleColorFamilies.value[0].id;
    couleursSectionOpen.value = true;
    motifsSectionOpen.value = false;
    return;
  }
  if (visibleMotifCategories.value[0]) {
    activeSection.value = "motifs";
    activeMotifCategory.value = visibleMotifCategories.value[0].id;
    motifsSectionOpen.value = true;
    couleursSectionOpen.value = false;
  }
});

const toggleColor = (id: number) => {
  if (isColorDisabled(id)) return;
  const index = localSelectedIds.value.indexOf(id);
  if (index === -1) {
    localSelectedIds.value.push(id);
  } else {
    localSelectedIds.value.splice(index, 1);
    const entry = colorPhotos.value.get(id);
    if (entry) {
      entry.previews.forEach((url) => URL.revokeObjectURL(url));
      colorPhotos.value.delete(id);
    }
    if (activeColorId.value === id) {
      activeColorId.value = localSelectedIds.value[0] ?? null;
    }
  }
};

const showSearchColorPage = (colorId: number) => {
  const motifCategory = visibleMotifCategories.value.find((category) =>
    (motifGroups.value[category.id] || []).some(
      (color) => Number(color.id_couleur) === colorId,
    ),
  );
  if (motifCategory) {
    selectMotifCategory(motifCategory.id);
    return;
  }
  const family = visibleColorFamilies.value.find((item) =>
    (colorGroups.value[item.id] || []).some(
      (color) => Number(color.id_couleur) === colorId,
    ),
  );
  if (family) selectColorFamily(family.id);
};

const selectSearchColor = (color: ColorOption) => {
  showSearchColorPage(color.id_couleur);
  toggleColor(color.id_couleur);
  clearSearch();
};

const clearSearch = () => {
  searchQuery.value = "";
  isSearchDropdownOpen.value = false;
  highlightedSearchIndex.value = -1;
  void nextTick(() => searchInputRef.value?.focus());
};

const openSearchDropdown = (event?: Event) => {
  const value =
    event?.target instanceof HTMLInputElement
      ? event.target.value
      : searchQuery.value;
  isSearchDropdownOpen.value = Boolean(value.trim());
};

const closeSearchDropdown = () => {
  isSearchDropdownOpen.value = false;
};

const moveSearchHighlight = (delta: number) => {
  isSearchDropdownOpen.value = true;
  const length = searchResults.value.length;
  if (!length) return;
  if (highlightedSearchIndex.value < 0) {
    highlightedSearchIndex.value = delta > 0 ? 0 : length - 1;
  } else {
    highlightedSearchIndex.value =
      (highlightedSearchIndex.value + delta + length) % length;
  }
};

const selectHighlightedSearchColor = () => {
  const color =
    searchResults.value[
      highlightedSearchIndex.value >= 0 ? highlightedSearchIndex.value : 0
    ];
  if (color && !isColorDisabled(color.id_couleur)) selectSearchColor(color);
};

const focusConfirmButton = () => {
  closeSearchDropdown();
  confirmButtonRef.value?.focus();
};

const focusSearchInput = () => {
  searchInputRef.value?.focus();
};

watch(searchQuery, () => {
  highlightedSearchIndex.value = -1;
});

const goToStep2 = () => {
  if (!localSelectedIds.value.length) return;
  currentStep.value = 2;
  activeColorId.value = localSelectedIds.value[0];
};

// ===== Helpers pour les photos par couleur =====

const getOrCreateColorEntry = (colorId: number): ColorPhotoEntry => {
  if (!colorPhotos.value.has(colorId)) {
    colorPhotos.value.set(colorId, {
      files: [],
      previews: new Map(),
      rotations: new Map(),
      coverIndex: 0,
    });
  }
  return colorPhotos.value.get(colorId)!;
};

const getColorLabel = (colorId: number) =>
  props.colors.find((c) => c.id_couleur === colorId)?.label ?? "";

const getColorFiles = (colorId: number) =>
  colorPhotos.value.get(colorId)?.files ?? [];

const getColorPhotoCount = (colorId: number) =>
  getColorFiles(colorId).length;

const getColorFilePreview = (colorId: number, file: File) =>
  colorPhotos.value.get(colorId)?.previews.get(file) ?? "";

const getColorFileRotation = (colorId: number, file: File) =>
  colorPhotos.value.get(colorId)?.rotations.get(file) ?? 0;

const getColorCoverIndex = (colorId: number) =>
  colorPhotos.value.get(colorId)?.coverIndex ?? 0;

const allColorsHavePhotos = computed(() =>
  localSelectedIds.value.every((id) => getColorPhotoCount(id) > 0)
);

const addFilesForColor = (colorId: number, files: File[]) => {
  const entry = getOrCreateColorEntry(colorId);
  files
    .filter((f) => ALLOWED_PHOTO_TYPES.has(f.type.toLowerCase()))
    .forEach((file) => {
      entry.files.push(file);
      entry.previews.set(file, URL.createObjectURL(file));
    });
};

const triggerFileDialogForColor = (colorId: number) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/jpeg,image/png,image/gif,image/webp,.dng";
  input.multiple = true;
  input.addEventListener("change", (event) => {
    const target = event.target as HTMLInputElement;
    if (target?.files) addFilesForColor(colorId, Array.from(target.files));
    input.remove();
  });
  input.click();
};

const handleDropForColor = (event: DragEvent, colorId: number) => {
  isDragging.value = false;
  if (event.dataTransfer?.files)
    addFilesForColor(colorId, Array.from(event.dataTransfer.files));
};

const rotateColorPhoto = (colorId: number, index: number) => {
  const entry = colorPhotos.value.get(colorId);
  if (!entry) return;
  const file = entry.files[index];
  const current = entry.rotations.get(file) ?? 0;
  entry.rotations.set(file, (current + 90) % 360);
};

const setColorCover = (colorId: number, index: number) => {
  const entry = colorPhotos.value.get(colorId);
  if (entry) entry.coverIndex = index;
};

// Drag & drop pour réordonner les photos d'une couleur (déposer en 1ère position = couverture)
const draggingColorPhotoIndex = ref<number | null>(null);
const dragOverColorPhotoIndex = ref<number | null>(null);

const handleColorPhotoDragStart = (event: DragEvent, index: number) => {
  draggingColorPhotoIndex.value = index;
  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", String(index));
  }
};

const handleColorPhotoDragEnd = () => {
  draggingColorPhotoIndex.value = null;
  dragOverColorPhotoIndex.value = null;
};

const handleColorPhotoDragOver = (event: DragEvent, index: number) => {
  if (draggingColorPhotoIndex.value === null) return;
  event.preventDefault();
  event.stopPropagation();
  dragOverColorPhotoIndex.value = index;
  if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
};

const handleColorPhotoDrop = (event: DragEvent, colorId: number, dropIndex: number) => {
  event.preventDefault();
  event.stopPropagation();
  const dragIndex = draggingColorPhotoIndex.value;
  draggingColorPhotoIndex.value = null;
  dragOverColorPhotoIndex.value = null;
  if (dragIndex === null || dragIndex === dropIndex) return;
  const entry = colorPhotos.value.get(colorId);
  if (!entry) return;
  // Mémoriser le fichier de couverture courant pour le suivre après réorganisation
  const currentCoverFile = entry.files[entry.coverIndex] ?? null;
  const [moved] = entry.files.splice(dragIndex, 1);
  entry.files.splice(dropIndex, 0, moved);
  // Déposer en 1ère position => devient la photo de couverture
  if (dropIndex === 0) {
    entry.coverIndex = 0;
  } else if (currentCoverFile) {
    const newCoverIndex = entry.files.indexOf(currentCoverFile);
    entry.coverIndex = newCoverIndex >= 0 ? newCoverIndex : 0;
  }
};

const removeColorFile = (colorId: number, index: number) => {
  const entry = colorPhotos.value.get(colorId);
  if (!entry) return;
  const file = entry.files[index];
  const preview = entry.previews.get(file);
  if (preview) {
    URL.revokeObjectURL(preview);
    entry.previews.delete(file);
  }
  entry.rotations.delete(file);
  entry.files.splice(index, 1);
  if (entry.coverIndex >= entry.files.length) {
    entry.coverIndex = Math.max(0, entry.files.length - 1);
  } else if (index < entry.coverIndex) {
    entry.coverIndex--;
  }
};

// ===== Mode mélangées =====

const triggerFileDialogMelangees = () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/jpeg,image/png,image/gif,image/webp,.dng";
  input.multiple = true;
  input.addEventListener("change", (event) => {
    const target = event.target as HTMLInputElement;
    if (target?.files) addMelangeesFiles(Array.from(target.files));
    input.remove();
  });
  input.click();
};

const handleDropMelangees = (event: DragEvent) => {
  isDragging.value = false;
  if (event.dataTransfer?.files)
    addMelangeesFiles(Array.from(event.dataTransfer.files));
};

const addMelangeesFiles = (files: File[]) => {
  files
    .filter((f) => ALLOWED_PHOTO_TYPES.has(f.type.toLowerCase()))
    .forEach((file) => {
      melangeesFiles.value.push(file);
      melangeesFilePreviews.value.set(file, URL.createObjectURL(file));
    });
};

const getMelangeesPreview = (file: File) =>
  melangeesFilePreviews.value.get(file) ?? "";

const getMelangeesRotation = (file: File) =>
  melangeesFileRotations.value.get(file) ?? 0;

const rotateMelangeesPhoto = (index: number) => {
  const file = melangeesFiles.value[index];
  const current = melangeesFileRotations.value.get(file) ?? 0;
  melangeesFileRotations.value.set(file, (current + 90) % 360);
};

const removeMelangeesFile = (index: number) => {
  const file = melangeesFiles.value[index];
  const preview = melangeesFilePreviews.value.get(file);
  if (preview) {
    URL.revokeObjectURL(preview);
    melangeesFilePreviews.value.delete(file);
  }
  melangeesFileRotations.value.delete(file);
  melangeesFiles.value.splice(index, 1);
  if (melangesCoverIndex.value >= melangeesFiles.value.length) {
    melangesCoverIndex.value = Math.max(0, melangeesFiles.value.length - 1);
  } else if (index < melangesCoverIndex.value) {
    melangesCoverIndex.value--;
  }
};

const handleClose = () => {
  emit("update:visible", false);
};

const handleSaveAndPublish = async () => {
  if (!props.product || !localSelectedIds.value.length) return;
  if (!allColorsHavePhotos.value) return;

  const variants = localSelectedIds.value.map((colorId) => {
    const entry = colorPhotos.value.get(colorId);
    const label = getColorLabel(colorId);
    const files = entry?.files ?? [];

    let orderedFiles = [...files];
    const coverIdx = entry?.coverIndex ?? 0;
    if (coverIdx > 0 && orderedFiles.length > 1) {
      const cover = orderedFiles.splice(coverIdx, 1)[0];
      orderedFiles.unshift(cover);
    }

    const rotations = orderedFiles.map(
      (file) => entry?.rotations.get(file) ?? 0,
    );

    return {
      couleurId: colorId,
      couleurName: label,
      photos: orderedFiles,
      rotations,
    };
  });

  emit("saveAndPublish", {
    productId: duplicateSourceProductId.value,
    variants,
  });

  // Cleanup
  colorPhotos.value.forEach((entry) => {
    entry.previews.forEach((url) => URL.revokeObjectURL(url));
  });
  colorPhotos.value = new Map();
  localSelectedIds.value = [];
  emit("update:visible", false);
};

const handleSave = async () => {
  if (!props.product) return;

  if (props.venduPar === "melangees") {
    if (!melangeesFiles.value.length) return;

    let orderedPhotos = [...melangeesFiles.value];
    if (melangesCoverIndex.value > 0 && orderedPhotos.length > 1) {
      const cover = orderedPhotos.splice(melangesCoverIndex.value, 1)[0];
      orderedPhotos.unshift(cover);
    }
    const rotations = orderedPhotos.map(
      (file) => melangeesFileRotations.value.get(file) ?? 0,
    );

    emit("save", {
      productId: duplicateSourceProductId.value,
      variants: [
        {
          couleurId: 0,
          couleurName: "",
          photos: orderedPhotos,
          rotations,
        },
      ],
    });

    melangeesFilePreviews.value.forEach((url) => URL.revokeObjectURL(url));
    melangeesFilePreviews.value.clear();
    melangeesFiles.value = [];
    emit("update:visible", false);
  } else {
    if (!localSelectedIds.value.length) return;

    const variants = localSelectedIds.value.map((colorId) => {
      const entry = colorPhotos.value.get(colorId);
      const label = getColorLabel(colorId);
      const files = entry?.files ?? [];

      let orderedFiles = [...files];
      const coverIdx = entry?.coverIndex ?? 0;
      if (coverIdx > 0 && orderedFiles.length > 1) {
        const cover = orderedFiles.splice(coverIdx, 1)[0];
        orderedFiles.unshift(cover);
      }

      const rotations = orderedFiles.map(
        (file) => entry?.rotations.get(file) ?? 0,
      );

      return {
        couleurId: colorId,
        couleurName: label,
        photos: orderedFiles.length ? orderedFiles : undefined,
        rotations: orderedFiles.length ? rotations : undefined,
      };
    });

    emit("save", {
      productId: duplicateSourceProductId.value,
      variants,
    });

    // Cleanup
    colorPhotos.value.forEach((entry) => {
      entry.previews.forEach((url) => URL.revokeObjectURL(url));
    });
    colorPhotos.value = new Map();
    localSelectedIds.value = [];
    emit("update:visible", false);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/40",
              onClick: handleClose,
              onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, null, 32),
            _createElementVNode("div", {
              class: "relative z-[1060] flex h-[100dvh] w-full max-w-none touch-manipulation flex-col overflow-hidden border-0 bg-white shadow-xl sm:h-[90dvh] sm:max-w-4xl sm:rounded-2xl sm:border sm:border-gray-100",
              onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
              onWheel: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
              onTouchmove: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.venduPar === "melangees" ? "Nouvelle photo" : "Nouvelle couleur"), 1),
                  (_ctx.product)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                        _cache[21] || (_cache[21] = _createTextVNode(" Produit : ")),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.product.reference_base || _ctx.product.reference), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.venduPar !== 'melangees' && currentStep.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        ref_key: "searchInputRef",
                        ref: searchInputRef,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                        type: "text",
                        autocomplete: "off",
                        placeholder: "Rechercher une couleur",
                        class: "w-full rounded-full border border-gray-300 py-2 pl-9 pr-9 text-sm focus:border-black focus:outline-none focus:ring-1 focus:ring-black",
                        role: "combobox",
                        "aria-expanded": isSearchDropdownOpen.value,
                        onFocus: openSearchDropdown,
                        onInput: openSearchDropdown,
                        onBlur: closeSearchDropdown,
                        onKeydown: [
                          _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (moveSearchHighlight(1)), ["prevent"]), ["down"])),
                          _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (moveSearchHighlight(-1)), ["prevent"]), ["up"])),
                          _withKeys(_withModifiers(selectHighlightedSearchColor, ["prevent"]), ["enter"]),
                          _withKeys(_withModifiers(focusConfirmButton, ["exact","prevent"]), ["tab"])
                        ]
                      }, null, 40, _hoisted_8), [
                        [
                          _vModelText,
                          searchQuery.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (searchQuery.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            tabindex: "-1",
                            class: "absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full p-1 text-gray-400 hover:text-black",
                            "aria-label": "Effacer la recherche",
                            onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                            onClick: clearSearch
                          }, _cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "fas fa-times text-xs" }, null, -1)
                          ]), 32))
                        : _createCommentVNode("", true),
                      (isSearchDropdownOpen.value && searchQuery.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (!searchResults.value.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Aucune couleur trouvée "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (color, index) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: `search-${color.id_couleur}`,
                                type: "button",
                                tabindex: "-1",
                                class: _normalizeClass(["flex w-full items-center gap-2 border-b border-gray-100 px-3 py-2 text-left text-sm last:border-b-0", [
                  index === highlightedSearchIndex.value ? 'bg-blue-100' : 'hover:bg-gray-100',
                  isColorDisabled(color.id_couleur) ? 'opacity-50' : '',
                ]]),
                                disabled: isColorDisabled(color.id_couleur),
                                onMousedown: _withModifiers(($event: any) => (selectSearchColor(color)), ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: "color-swatch-dot h-4 w-4 flex-shrink-0 rounded-full",
                                  style: _normalizeStyle(_unref(getColorSwatchStyle)(color.label, color.hexColor))
                                }, null, 4),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(color.label), 1),
                                (isColorDisabled(color.id_couleur))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Utilisée"))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_11))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.venduPar !== 'melangees' && currentStep.value === 1 && localSelectedIds.value.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(localSelectedIds.value.length) + " sél. ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "p-2 rounded-full hover:bg-gray-100 text-black flex-shrink-0",
                  onClick: handleClose
                }, _cache[24] || (_cache[24] = [
                  _createElementVNode("span", { class: "sr-only" }, "Fermer", -1),
                  _createTextVNode(" ✕ ")
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-1 min-h-0 flex flex-col", currentStep.value === 1 && _ctx.venduPar !== 'melangees' ? 'overflow-hidden' : 'px-3 sm:px-6 py-2 overflow-y-auto']),
                style: {"overscroll-behavior":"contain"}
              }, [
                (_ctx.venduPar === 'melangees')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-xs text-black mb-2" }, "Ajoutez des photos pour ce produit.", -1)),
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "mb-4 flex items-start gap-2 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800" }, [
                        _createElementVNode("i", { class: "fas fa-info-circle mt-0.5 flex-shrink-0" }),
                        _createElementVNode("span", null, " Si vous utilisez des photos IA, ajoutez également au moins une photo réelle du produit sur cintre. ")
                      ], -1)),
                      _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-sm font-semibold text-black mb-3" }, "Photos du produit", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        (melangeesFiles.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(melangeesFiles.value, (file, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "relative w-28 h-28 flex-shrink-0 bg-gray-100 rounded overflow-hidden flex items-center justify-center border border-gray-300 cursor-pointer",
                                    onClick: ($event: any) => (toggleOverlay('melangees', index))
                                  }, [
                                    _createElementVNode("img", {
                                      src: getMelangeesPreview(file),
                                      alt: `Photo ${index + 1}`,
                                      class: "max-w-full max-h-full object-contain rounded",
                                      style: _normalizeStyle({ transform: `rotate(${getMelangeesRotation(file)}deg)` })
                                    }, null, 12, _hoisted_20),
                                    (melangesCoverIndex.value === index)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[25] || (_cache[25] = [
                                          _createTextVNode(" Photo de"),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode("couverture ")
                                        ])))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["absolute inset-0 bg-black/40 transition-opacity grid grid-cols-2 place-items-center gap-1 p-4", activeOverlay.value === `melangees-${index}` ? 'opacity-100' : 'opacity-0 pointer-events-none'])
                                    }, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["p-2 bg-white/90 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90", melangesCoverIndex.value === index ? 'text-yellow-500' : 'text-black']),
                                        title: "Définir comme photo de couverture",
                                        onClick: _withModifiers(($event: any) => (melangesCoverIndex.value = index), ["stop"])
                                      }, _cache[26] || (_cache[26] = [
                                        _createElementVNode("i", { class: "fas fa-star text-sm" }, null, -1)
                                      ]), 10, _hoisted_22),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "p-2 bg-white/90 text-blue-600 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90",
                                        title: "Pivoter la photo",
                                        onClick: _withModifiers(($event: any) => (rotateMelangeesPhoto(index)), ["stop"])
                                      }, _cache[27] || (_cache[27] = [
                                        _createElementVNode("i", { class: "fas fa-redo-alt text-sm" }, null, -1)
                                      ]), 8, _hoisted_23),
                                      _createElementVNode("a", {
                                        href: getMelangeesPreview(file),
                                        download: file.name,
                                        class: "p-2 bg-white/90 text-black rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90 flex items-center justify-center",
                                        title: "Télécharger",
                                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                      }, _cache[28] || (_cache[28] = [
                                        _createElementVNode("i", { class: "fas fa-download text-sm" }, null, -1)
                                      ]), 8, _hoisted_24),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "p-2 bg-white/90 text-red-600 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90",
                                        title: "Supprimer la photo",
                                        onClick: _withModifiers(($event: any) => (removeMelangeesFile(index)), ["stop"])
                                      }, _cache[29] || (_cache[29] = [
                                        _createElementVNode("i", { class: "fas fa-trash-alt text-sm" }, null, -1)
                                      ]), 8, _hoisted_25)
                                    ], 2)
                                  ], 8, _hoisted_19))
                                }), 128))
                              ]),
                              (melangeesFiles.value.length > 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[30] || (_cache[30] = [
                                    _createElementVNode("i", { class: "fas fa-chevron-right text-black text-sm" }, null, -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["border-2 border-dashed rounded-lg p-2 md:p-6 text-center transition-colors md:order-1", isDragging.value ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400']),
                          onDragenter: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
                          onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                          onDragleave: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (isDragging.value = false), ["prevent"])),
                          onDrop: _withModifiers(handleDropMelangees, ["prevent"])
                        }, [
                          _createElementVNode("div", { class: "text-black" }, [
                            _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-cloud-upload-alt text-lg md:text-3xl mb-0.5 md:mb-2" }, null, -1)),
                            _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-[11px] md:text-sm" }, "Glissez-déposez ou cliquez", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "mt-1 md:mt-2 px-3 md:px-4 py-1 md:py-2 text-xs md:text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700",
                              onClick: triggerFileDialogMelangees
                            }, " Parcourir "),
                            _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-[10px] md:text-xs text-black mt-0.5 md:mt-2" }, "Les photos uploadées ne peuvent pas dépasser 15 Mo.", -1))
                          ])
                        ], 34)
                      ])
                    ]))
                  : (currentStep.value === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          (visibleColorFamilies.value.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "flex items-center justify-between px-3 py-2 text-sm font-bold text-black uppercase tracking-wide",
                                  onClick: toggleCouleursSection
                                }, [
                                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "Couleurs", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': couleursSectionOpen.value }])
                                  }, null, 2)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["collapse-panel", couleursSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                                }, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColorFamilies.value, (family) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: 'mc-' + family.id,
                                          type: "button",
                                          class: _normalizeClass(["flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs whitespace-nowrap border flex-shrink-0 transition-colors", navButtonClass('couleurs', family.id)]),
                                          onClick: ($event: any) => (selectColorFamily(family.id))
                                        }, [
                                          _createElementVNode("span", {
                                            class: "color-swatch-dot w-3.5 h-3.5 rounded-full flex-shrink-0",
                                            style: _normalizeStyle(familySwatchStyle(family))
                                          }, null, 4),
                                          _createTextVNode(" " + _toDisplayString(family.label) + " ", 1),
                                          (pendingCountByColorFamily.value[family.id])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "(" + _toDisplayString(pendingCountByColorFamily.value[family.id]) + ")", 1))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_31))
                                      }), 128))
                                    ])
                                  ])
                                ], 2)
                              ], 64))
                            : _createCommentVNode("", true),
                          (visibleMotifCategories.value.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["flex items-center justify-between px-3 py-2 text-sm font-bold text-black uppercase tracking-wide", visibleColorFamilies.value.length ? 'border-t border-gray-100' : '']),
                                  onClick: toggleMotifsSection
                                }, [
                                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "Motifs", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': motifsSectionOpen.value }])
                                  }, null, 2)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["collapse-panel", motifsSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMotifCategories.value, (category) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: 'mm-' + category.id,
                                          type: "button",
                                          class: _normalizeClass(["flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs whitespace-nowrap border flex-shrink-0 transition-colors", navButtonClass('motifs', category.id)]),
                                          onClick: ($event: any) => (selectMotifCategory(category.id))
                                        }, [
                                          _createTextVNode(_toDisplayString(category.label) + " ", 1),
                                          (pendingCountByMotifCategory.value[category.id])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, "(" + _toDisplayString(pendingCountByMotifCategory.value[category.id]) + ")", 1))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_35))
                                      }), 128))
                                    ])
                                  ])
                                ], 2)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("aside", _hoisted_38, [
                            (visibleColorFamilies.value.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "w-full flex items-center justify-between px-3 py-2.5 text-sm font-bold text-black uppercase tracking-wide hover:bg-white/70 transition-colors",
                                    onClick: toggleCouleursSection
                                  }, [
                                    _cache[39] || (_cache[39] = _createElementVNode("span", null, "Couleurs", -1)),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': couleursSectionOpen.value }])
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["collapse-panel", couleursSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                                  }, [
                                    _createElementVNode("div", _hoisted_39, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColorFamilies.value, (family) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: family.id,
                                          type: "button",
                                          class: _normalizeClass(["w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition-colors", sidebarItemClass('couleurs', family.id)]),
                                          onClick: ($event: any) => (selectColorFamily(family.id))
                                        }, [
                                          _createElementVNode("span", {
                                            class: "color-swatch-dot w-5 h-5 rounded-full flex-shrink-0",
                                            style: _normalizeStyle(familySwatchStyle(family))
                                          }, null, 4),
                                          _createElementVNode("span", _hoisted_41, _toDisplayString(family.label), 1),
                                          (pendingCountByColorFamily.value[family.id])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, " (" + _toDisplayString(pendingCountByColorFamily.value[family.id]) + ") ", 1))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_40))
                                      }), 128))
                                    ])
                                  ], 2)
                                ], 64))
                              : _createCommentVNode("", true),
                            (visibleMotifCategories.value.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["w-full flex items-center justify-between px-3 py-2.5 text-sm font-bold text-black uppercase tracking-wide hover:bg-white/70 transition-colors", visibleColorFamilies.value.length ? 'border-t border-gray-200' : '']),
                                    onClick: toggleMotifsSection
                                  }, [
                                    _cache[40] || (_cache[40] = _createElementVNode("span", null, "Motifs", -1)),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': motifsSectionOpen.value }])
                                    }, null, 2)
                                  ], 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["collapse-panel", motifsSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                                  }, [
                                    _createElementVNode("div", _hoisted_43, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMotifCategories.value, (category) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: category.id,
                                          type: "button",
                                          class: _normalizeClass(["w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition-colors", sidebarItemClass('motifs', category.id)]),
                                          onClick: ($event: any) => (selectMotifCategory(category.id))
                                        }, [
                                          _createElementVNode("span", _hoisted_45, _toDisplayString(category.label), 1),
                                          (pendingCountByMotifCategory.value[category.id])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, " (" + _toDisplayString(pendingCountByMotifCategory.value[category.id]) + ") ", 1))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_44))
                                      }), 128))
                                    ])
                                  ], 2)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("section", _hoisted_47, [
                            (panelTitle.value)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_48, _toDisplayString(panelTitle.value), 1))
                              : _createCommentVNode("", true),
                            (displayedShades.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(searchQuery.value
                      ? "Aucune couleur trouvée"
                      : activeSection.value === "motifs"
                        ? "Aucun motif dans cette famille"
                        : "Aucune couleur dans cette famille"), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedShades.value, (color) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: color.id_couleur,
                                      type: "button",
                                      class: _normalizeClass(["group text-left focus:outline-none", [
                      isColorDisabled(color.id_couleur)
                        ? 'opacity-40 cursor-not-allowed'
                        : '',
                      activeSection.value === 'motifs'
                        ? localSelectedIds.value.includes(color.id_couleur)
                          ? 'rounded-md border border-black ring-1 ring-black px-2.5 py-2'
                          : 'rounded-md border border-gray-200 px-2.5 py-2 hover:border-gray-400'
                        : '',
                    ]]),
                                      title: 
                      isColorDisabled(color.id_couleur)
                        ? 'Cette couleur est déjà utilisée'
                        : ''
                    ,
                                      disabled: isColorDisabled(color.id_couleur),
                                      onClick: ($event: any) => (toggleColor(color.id_couleur))
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["text-xs sm:text-sm text-black truncate flex items-center justify-between gap-2", activeSection.value === 'motifs' ? '' : 'mb-1.5'])
                                      }, [
                                        _createElementVNode("span", _hoisted_52, [
                                          _createTextVNode(_toDisplayString(color.label) + " ", 1),
                                          (isColorDisabled(color.id_couleur))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, "(utilisée)"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (
                          activeSection.value === 'motifs' &&
                          localSelectedIds.value.includes(color.id_couleur)
                        )
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_54))
                                          : _createCommentVNode("", true)
                                      ], 2),
                                      (activeSection.value !== 'motifs')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["relative w-full h-12 sm:h-16 rounded-md border overflow-hidden transition-all", 
                        localSelectedIds.value.includes(color.id_couleur)
                          ? 'border-black ring-1 ring-black'
                          : 'border-gray-200 group-hover:border-gray-400'
                      ]),
                                            style: _normalizeStyle(_unref(getColorSwatchStyle)(color.label, color.hexColor))
                                          }, [
                                            (localSelectedIds.value.includes(color.id_couleur))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, _cache[41] || (_cache[41] = [
                                                  _createElementVNode("i", { class: "fas fa-check text-[8px]" }, null, -1)
                                                ])))
                                              : _createCommentVNode("", true)
                                          ], 6))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_51))
                                  }), 128))
                                ]))
                          ])
                        ])
                      ]))
                    : (currentStep.value === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _cache[52] || (_cache[52] = _createElementVNode("div", { class: "mb-4 text-xs text-black" }, [
                            _createTextVNode(" Ajoutez des photos pour chaque couleur sélectionnée. Cliquez sur l'onglet d'une couleur pour gérer ses photos. "),
                            _createElementVNode("span", { class: "block mt-1 text-amber-600" }, [
                              _createElementVNode("i", { class: "fas fa-info-circle mr-1" }),
                              _createTextVNode(" Si vous utilisez des photos IA, ajoutez également au moins une photo réelle du produit sur cintre. ")
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_57, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localSelectedIds.value, (colorId) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: colorId,
                                type: "button",
                                class: _normalizeClass([
                  'px-3 py-1.5 text-sm rounded-t-lg border-b-2 transition-colors flex items-center gap-1.5',
                  activeColorId.value === colorId
                    ? 'border-blue-600 text-blue-600 font-medium bg-blue-50'
                    : 'border-transparent text-black hover:text-black hover:bg-gray-50',
                ]),
                                onClick: ($event: any) => (activeColorId.value = colorId)
                              }, [
                                _createTextVNode(_toDisplayString(getColorLabel(colorId)) + " ", 1),
                                (getColorPhotoCount(colorId) > 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full", activeColorId.value === colorId ? 'bg-blue-600 text-white' : 'bg-gray-300 text-black'])
                                    }, _toDisplayString(getColorPhotoCount(colorId)), 3))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_59, "!"))
                              ], 10, _hoisted_58))
                            }), 128))
                          ]),
                          (activeColorId.value !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _createElementVNode("p", _hoisted_61, [
                                  _cache[42] || (_cache[42] = _createTextVNode(" Photos pour ")),
                                  _createElementVNode("strong", _hoisted_62, _toDisplayString(getColorLabel(activeColorId.value)), 1)
                                ]),
                                (getColorFiles(activeColorId.value).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getColorFiles(activeColorId.value), (file, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: _normalizeClass(["relative w-28 h-28 flex-shrink-0 bg-gray-100 rounded overflow-hidden flex items-center justify-center border border-gray-300 cursor-move", [
                    draggingColorPhotoIndex.value === index ? 'opacity-50 scale-95' : '',
                    dragOverColorPhotoIndex.value === index ? 'ring-2 ring-blue-400 ring-offset-1' : '',
                  ]]),
                                            draggable: "true",
                                            onClick: ($event: any) => (toggleOverlay('color', index)),
                                            onDragstart: ($event: any) => (handleColorPhotoDragStart($event, index)),
                                            onDragend: _cache[11] || (_cache[11] = ($event: any) => (handleColorPhotoDragEnd())),
                                            onDragover: ($event: any) => (handleColorPhotoDragOver($event, index)),
                                            onDrop: ($event: any) => (handleColorPhotoDrop($event, activeColorId.value, index))
                                          }, [
                                            _createElementVNode("img", {
                                              src: getColorFilePreview(activeColorId.value, file),
                                              alt: `Photo ${index + 1}`,
                                              class: "max-w-full max-h-full object-contain rounded pointer-events-none",
                                              style: _normalizeStyle({ transform: `rotate(${getColorFileRotation(activeColorId.value, file)}deg)` })
                                            }, null, 12, _hoisted_66),
                                            (getColorCoverIndex(activeColorId.value) === index)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, _cache[43] || (_cache[43] = [
                                                  _createTextVNode(" Photo de"),
                                                  _createElementVNode("br", null, null, -1),
                                                  _createTextVNode("couverture ")
                                                ])))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["absolute inset-0 bg-black/40 transition-opacity grid grid-cols-2 place-items-center gap-1 p-4", activeOverlay.value === `color-${index}` ? 'opacity-100' : 'opacity-0 pointer-events-none'])
                                            }, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: _normalizeClass(["p-2 bg-white/90 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90", getColorCoverIndex(activeColorId.value) === index ? 'text-yellow-500' : 'text-black']),
                                                title: "Définir comme photo de couverture",
                                                onClick: _withModifiers(($event: any) => (setColorCover(activeColorId.value, index)), ["stop"])
                                              }, _cache[44] || (_cache[44] = [
                                                _createElementVNode("i", { class: "fas fa-star text-sm" }, null, -1)
                                              ]), 10, _hoisted_68),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "p-2 bg-white/90 text-blue-600 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90",
                                                title: "Pivoter la photo",
                                                onClick: _withModifiers(($event: any) => (rotateColorPhoto(activeColorId.value, index)), ["stop"])
                                              }, _cache[45] || (_cache[45] = [
                                                _createElementVNode("i", { class: "fas fa-redo-alt text-sm" }, null, -1)
                                              ]), 8, _hoisted_69),
                                              _createElementVNode("a", {
                                                href: getColorFilePreview(activeColorId.value, file),
                                                download: file.name,
                                                class: "p-2 bg-white/90 text-black rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90 flex items-center justify-center",
                                                title: "Télécharger",
                                                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                                              }, _cache[46] || (_cache[46] = [
                                                _createElementVNode("i", { class: "fas fa-download text-sm" }, null, -1)
                                              ]), 8, _hoisted_70),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "p-2 bg-white/90 text-red-600 rounded-full hover:bg-white focus:outline-none transition-transform hover:scale-90",
                                                title: "Supprimer la photo",
                                                onClick: _withModifiers(($event: any) => (removeColorFile(activeColorId.value, index)), ["stop"])
                                              }, _cache[47] || (_cache[47] = [
                                                _createElementVNode("i", { class: "fas fa-trash-alt text-sm" }, null, -1)
                                              ]), 8, _hoisted_71)
                                            ], 2)
                                          ], 42, _hoisted_65))
                                        }), 128))
                                      ]),
                                      (getColorFiles(activeColorId.value).length > 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, _cache[48] || (_cache[48] = [
                                            _createElementVNode("i", { class: "fas fa-chevron-right text-black text-sm" }, null, -1)
                                          ])))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["border-2 border-dashed rounded-lg p-2 md:p-6 text-center transition-colors", isDragging.value ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400']),
                                  onDragenter: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
                                  onDragover: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
                                  onDragleave: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (isDragging.value = false), ["prevent"])),
                                  onDrop: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (handleDropForColor($event, activeColorId.value)), ["prevent"]))
                                }, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _cache[49] || (_cache[49] = _createElementVNode("i", { class: "fas fa-cloud-upload-alt text-lg md:text-3xl mb-0.5 md:mb-2" }, null, -1)),
                                    _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-[11px] md:text-sm" }, "Glissez-déposez ou cliquez", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "mt-1 md:mt-2 px-3 md:px-4 py-1 md:py-2 text-xs md:text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (triggerFileDialogForColor(activeColorId.value)))
                                    }, " Parcourir "),
                                    _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-[10px] md:text-xs text-black mt-0.5 md:mt-2" }, "Les photos uploadées ne peuvent pas dépasser 15 Mo.", -1))
                                  ])
                                ], 34)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_74, [
                (uploadError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _cache[53] || (_cache[53] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(uploadError.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_76, [
                  (_ctx.venduPar !== 'melangees' && currentStep.value === 2)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "px-3 sm:px-4 py-2 text-sm rounded-lg border border-gray-300 text-black hover:bg-gray-50",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (currentStep.value = 1))
                      }, " Retour "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_77)),
                  _createElementVNode("div", _hoisted_78, [
                    (_ctx.venduPar !== 'melangees' && currentStep.value === 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          ref_key: "confirmButtonRef",
                          ref: confirmButtonRef,
                          type: "button",
                          class: "px-4 py-2.5 sm:py-2 text-sm rounded-lg bg-black text-white hover:bg-gray-800 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed",
                          disabled: !localSelectedIds.value.length,
                          onClick: goToStep2,
                          onKeydown: _withKeys(_withModifiers(focusSearchInput, ["exact","prevent"]), ["tab"])
                        }, " Suivant : Photos ", 40, _hoisted_79))
                      : (_ctx.venduPar !== 'melangees' && currentStep.value === 2)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "px-3 sm:px-4 py-2 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed",
                            disabled: isUploading.value,
                            onClick: handleSave
                          }, [
                            (isUploading.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, _cache[54] || (_cache[54] = [
                                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1),
                                  _createTextVNode("Upload...")
                                ])))
                              : (_openBlock(), _createElementBlock("span", _hoisted_82, "Créer " + _toDisplayString(localSelectedIds.value.length) + " variante" + _toDisplayString(localSelectedIds.value.length > 1 ? 's' : ''), 1))
                          ], 8, _hoisted_80))
                        : _createCommentVNode("", true),
                    (_ctx.venduPar !== 'melangees' && currentStep.value === 2)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "px-3 sm:px-4 py-2 text-sm rounded-lg bg-green-600 text-white hover:bg-green-700 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed",
                          disabled: isUploading.value || !allColorsHavePhotos.value,
                          onClick: handleSaveAndPublish
                        }, [
                          (isUploading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_84, _cache[55] || (_cache[55] = [
                                _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1),
                                _createTextVNode("Upload...")
                              ])))
                            : (_openBlock(), _createElementBlock("span", _hoisted_85, _cache[56] || (_cache[56] = [
                                _createElementVNode("i", { class: "fas fa-cloud-upload-alt mr-1" }, null, -1),
                                _createTextVNode("En ligne")
                              ])))
                        ], 8, _hoisted_83))
                      : (_ctx.venduPar === 'melangees')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "px-4 py-2 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed",
                            disabled: isUploading.value || !melangeesFiles.value.length,
                            onClick: handleSave
                          }, [
                            (isUploading.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, _cache[57] || (_cache[57] = [
                                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1),
                                  _createTextVNode("Upload...")
                                ])))
                              : (_openBlock(), _createElementBlock("span", _hoisted_88, "Ajouter les photos"))
                          ], 8, _hoisted_86))
                        : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})